/**
 * <s-quote-choice> — Reveals the email quote form when the Email choice is pressed.
 * Without JS the form stays visible, so customers can always use it.
 *
 * Required child markup:
 *   [data-quote-toggle] — button with aria-controls pointing at the form panel id.
 *   #<panel id>         — the panel to show/hide. Add data-open to keep it open on load
 *                         (e.g. after a submission or validation error).
 */
class SQuoteChoice extends HTMLElement {
  #ac;

  connectedCallback() {
    const toggle = this.querySelector('[data-quote-toggle]');
    const panel = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
    if (!toggle || !panel) return;

    this.#ac = new AbortController();
    const open = panel.hasAttribute('data-open');
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));

    toggle.addEventListener('click', () => {
      const next = panel.hidden;
      panel.hidden = !next;
      toggle.setAttribute('aria-expanded', String(next));
      if (next) panel.querySelector('input:not([type="hidden"])')?.focus();
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-quote-choice')) customElements.define('s-quote-choice', SQuoteChoice);
